import { render, staticRenderFns } from "./ExecMarketing.vue?vue&type=template&id=c5509502"
import script from "./ExecMarketing.vue?vue&type=script&lang=js"
export * from "./ExecMarketing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports